import {ValidationSummary} from 'devextreme-react/validation-summary';
import {Box, Item} from 'devextreme-react/box';
import Toolbar, {Item as ToolbarItem} from 'devextreme-react/toolbar';
import {
    ExitButton,
    PrintButton,
    SaveButton,
    ScheduleDatePanel,
    SetToPendingButton,
    WorkOrderAddNoteButton,
    WorkOrderFilesButton,
    WorkOrderInformationCards,
    WorkOrderNotesPanel,
    WorkOrderPage,
    WorkOrderProductsPanel,
    WorkOrderProgress,
    WorkOrderProgressStep
} from '../../../features/cfi/work-order';
import '../../../css/order.scss';

export default function WorkOrderSchedulePage() {

	return (
		<WorkOrderPage>

			<WorkOrderInformationCards />

			<WorkOrderProgress />

			<ValidationSummary />

			<Toolbar className='button-toolbar'>
				<ToolbarItem location={'before'}>
					<SaveButton step={WorkOrderProgressStep.Schedule} />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<PrintButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<WorkOrderFilesButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<SetToPendingButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<ExitButton />
				</ToolbarItem>
				<ToolbarItem location={'after'}>
					<WorkOrderAddNoteButton />
				</ToolbarItem>
			</Toolbar>

			<Box>
				<Item ratio={1}>
					<ScheduleDatePanel />
				</Item>
				<Item ratio={1}>
					<WorkOrderNotesPanel height={200} />
				</Item>
			</Box>

			<WorkOrderProductsPanel />
		
		</WorkOrderPage>
	)
}
